import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'
import { useFormattingContext } from '../FormattingProvider/FormattingContext'
import FadeIn from '../../molecules/Transitions/FadeIn'
import { useStatusReportContext } from './statusReportContext'

const useStyles = makeStyles((theme) => ({
  asOfDate: {
    fontWeight: theme.typography.weights.light
  }
}))

function StatusReportAsOfDate ({ format, className, style, prefixText }) {
  const classes = useStyles()
  const { report, isLoading } = useStatusReportContext()
  const { formatter } = useFormattingContext()

  if (isLoading) return null

  if (!report?.asOfDate) return null

  return (
    <FadeIn className={clsx(classes.asOfDate, className)} style={style}>{prefixText}{formatter(report.asOfDate, format)}</FadeIn>
  )
}

StatusReportAsOfDate.propTypes = {
  format: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  prefixText: PropTypes.string
}

StatusReportAsOfDate.defaultProps = {
  prefixText: 'As of ',
  format: '@MMM D, YYYY'
}

export default StatusReportAsOfDate
